import { HlsJsVideo } from '@videojs/react/media/hlsjs-video';
import { VideoPlayer, VideoSkin } from '@videojs/react/video';
import '@videojs/react/video/skin.css';

interface Source {
    src: string;
    type: string;
}

interface Props {
    autoplay?: boolean;
    source: Source;
    startTime?: number;
    onTimeUpdate?: (time: number, media: HTMLVideoElement) => void;
    onEnd?: (time: number, media: HTMLVideoElement) => void;
}

const FILL_STYLE = { width: '100%', height: '100%' };

export const VideoJSPlayer = ({ autoplay = false, onEnd, onTimeUpdate, source, startTime = 0 }: Props) => (
    <VideoPlayer>
        <VideoSkin style={FILL_STYLE}>
            <HlsJsVideo
                source={source}
                autoPlay={autoplay}
                preload="auto"
                playsInline
                onLoadedMetadata={(event) => {
                    if (startTime > 0) {
                        event.currentTarget.currentTime = startTime;
                    }
                }}
                onTimeUpdate={(event) => {
                    onTimeUpdate?.(event.currentTarget.currentTime, event.currentTarget);
                }}
                onEnded={(event) => {
                    onEnd?.(event.currentTarget.currentTime, event.currentTarget);
                }}
            />
        </VideoSkin>
    </VideoPlayer>
);
